import ExclamationTriangleIcon from "@heroicons/react/24/solid/esm/ExclamationTriangleIcon";

export const Error: React.FC<{ message: string; display: boolean }> = ({
  message,
  display,
}) => {
  return display ? (
    <div className="flex items-center">
      <div className="flex-shrink-0">
        <ExclamationTriangleIcon
          className="h-4 w-4 text-red-400"
          aria-hidden="true"
        />
      </div>
      <div className="flex ml-1">
        <h3 className="text-xs font-medium text-red-800">{message}</h3>
      </div>
    </div>
  ) : null;
};
